export const jarvisRMSActionCenterConstants = {
    GET_RMS_ACTION_CENTER_DATA_SAGA : "GET_RMS_ACTION_CENTER_DATA_SAGA",
    GET_RMS_ACTION_CENTER_DATA_APIS: "rms/action-centre",
    GET_RMS_ACTION_CENTER_DATA_REQUEST : "GET_RMS_ACTION_CENTER_DATA_REQUEST",
    GET_RMS_ACTION_CENTER_DATA_RESPONSE : "GET_RMS_ACTION_CENTER_DATA_RESPONSE",
}